import { composeMessage } from "@memorang/helpers/email";
import { useTranslation } from "react-i18next";
import { Platform } from "react-native";
import { Dialog, Paragraph } from "react-native-paper";
import Button from "../../Button";
import DialogWrapper from "../../DialogWrapper";

type Props = {
	visible: boolean;
	handleDismiss: () => void;
	companyName: string;
	supportEmail: string;
	buildType: string;
	currentAppVersion: string;
};

const ContactSupportDialog = ({
	visible,
	handleDismiss,
	companyName,
	supportEmail,
	buildType,
	currentAppVersion,
}: Props) => {
	const { t } = useTranslation();

	const handleComposeMessage = () => {
		const subject = `[${companyName}] Trouble logging in`;
		const emailBody = `Hi, I have the ${Platform.OS} version of the ${buildType} app version ${currentAppVersion} and I'm having trouble logging in with my ${buildType} account`;
		composeMessage(subject, emailBody, supportEmail);
	};

	return (
		<DialogWrapper visible={visible} handleClose={handleDismiss} maxWidth="xs">
			<Dialog.Title>{t("auth.contactSupportDialog.title")}</Dialog.Title>
			<Dialog.Content>
				<Paragraph>{t("auth.contactSupportDialog.body")}</Paragraph>
			</Dialog.Content>
			<Dialog.Actions>
				<Button onPress={handleComposeMessage}>
					{t("auth.contactSupportDialog.cta")}
				</Button>
			</Dialog.Actions>
		</DialogWrapper>
	);
};

export default ContactSupportDialog;
